import type { FrontendModule } from "@backstage/frontend-plugin-api";
import { createFrontendModule } from "@backstage/frontend-plugin-api";

import { cloudFindingsContent } from "./entityContents";

/**
 * Frontend module that registers the GCP Security Findings entity content
 * extension into the `google` plugin.
 *
 * @alpha
 */
const gcpSecurityFindingsModule: FrontendModule = createFrontendModule({
    pluginId: "google",
    extensions: [cloudFindingsContent],
});

export default gcpSecurityFindingsModule;
